import React from "react";

const StressFreeMaintenanceSVG = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 128 128"
      xmlSpace="preserve"
    >
      <style>
        {`
        .st3, .st4 {
          fill: none;
          stroke: #063;
          strokeWidth: 2;
          strokeLinecap: round;
          stroke-miterlimit: 10;
        }
        .st4 {
          stroke: #063;
        }
      `}
      </style>
      <path
        d="M54.1 50.2s-4.4 7.1-24.7 17.7l28.3 28.3c10.5-20.4 17.7-24.7 17.7-24.7"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        fill="none"
        stroke="#063"
        strokeWidth="2.078"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M55.3 76.8l-8.5 8.5"
      />
      <path
        fill="none"
        stroke="#063"
        strokeWidth="2.02"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M44.1 74.1l-4.2 4.3"
      />
      <circle className="st3" cx="76.8" cy="95.3" r="6" />
      <circle className="st3" cx="88.1" cy="84" r="4.5" />
      <circle className="st3" cx="94.5" cy="97.4" r="3" />
      <path
        className="st4"
        d="M98.6 26.7L72 53.3M78.1 59.9L65.4 47.2c-2.3-2.3-5.8-2.6-7.8-.7L54 50.1l4.2 4.2L71 67.1l4.2 4.2 3.6-3.6c2-1.9 1.7-5.4-.7-7.8z"
      />
    </svg>
  );
};

export default StressFreeMaintenanceSVG;
